import _ from "lodash";
import { postRequest, uploadEncodedFile } from "@network";
import { INSTANCE_URL, BASE_IMAGES_URL } from "@constant";
import { generateFileName } from "@utilscommon";

import { categorizeForms } from "@registrationaction";

export const PROPOSAL_DATA = "PROPOSAL_DATA";

export const fetchProposalData = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;
  let body = { ...data, type: "getproposal" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          dispatch({
            type: PROPOSAL_DATA,
            payload: { code: response?.code, data: response?.resource ?? {} },
          });
          dispatch(
            categorizeForms({ ...response?.resource, formtype: "proposal" })
          );
          callback({
            success: 1,
            code: response?.code,
            data: response?.resource ?? {},
          });
        } else {
          dispatch({
            type: PROPOSAL_DATA,
            payload: { data: {}, error: response },
          });
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        dispatch({ type: PROPOSAL_DATA, payload: { data: {} } });
        callback({ success: 0 });
      }
    );
  };
};

export function proposalRequest(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;

  let eventid = values.eventid;
  let checkoutData = JSON.parse(values?.responses);
  let otherFilesData = _.filter(checkoutData, (form) => {
    return form?.key === "file" && form?.value?.length > 0;
  });

  return (dispatch) => {
    _uploadDynamicFormsFiles(
      session,
      eventid,
      otherFilesData,
      dispatch,
      (filesArray) => {
        _.map(checkoutData, (obj) => {
          let check = _.filter(filesArray, function (file) {
            return file.name === obj.name;
          });

          if (check?.length > 0) {
            obj.value = check[0].value;
          }
        });
        // console.log("new checkoutData :- ", checkoutData);

        values = {
          ...values,
          responses: JSON.stringify(checkoutData),
        };
        let body = { ...values, type: "proposalrequest" };
        // console.log("body :- ", body);

        postRequest(
          url,
          body,
          session,
          dispatch,
          (response) => {
            // console.log("call response :- ", response);
            if (response.success) {
              callback({ success: 1, data: response });
            } else {
              callback({ success: 2, data: response });
            }
          },
          (error) => {
            callback({ success: 0, message: error });
          }
        );
      }
    );
  };
}

export function _uploadDynamicFormsFiles(
  session,
  eventid,
  otherFilesData,
  dispatch,
  callback
) {
  let filepath = `eventify/${eventid}/files/proposal`;
  var folderJson = {
    resource: [
      {
        name: `${filepath}`,
        type: "folder",
      },
    ],
  };

  // Create folder first
  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    folderJson,
    dispatch,
    (data) => {
      // uploadFiles
      let promiseArray = [];
      _.map(otherFilesData, (field, key) => {
        // Files base64 value
        let savedValues = field.value;
        let uploadFiles = [];
        _.map(savedValues, (item, index) => {
          if (item) {
            promiseArray.push(
              new Promise((resolve, reject) => {
                let file = item?.file;
                let name = item?.filename;
                if (file.search(";base64,") > 0) {
                  let split = file.split(";base64,");
                  var content = split[1];
                  var filename = `${filepath}/${generateFileName(name)}`;

                  var fileJson = {
                    resource: [
                      {
                        name: filename,
                        type: "file",
                        is_base64: true,
                        content: content,
                      },
                    ],
                  };

                  uploadEncodedFile(
                    `${BASE_IMAGES_URL}?check_exist=false`,
                    session,
                    fileJson,
                    dispatch,
                    (data) => {
                      uploadFiles.push(data.name);
                      resolve();
                    },
                    (error) => {
                      resolve();
                    }
                  );
                } else {
                  uploadFiles.push(file);
                  resolve();
                }
              })
            );
          }
        });

        field.value = uploadFiles;
      });

      Promise.all(promiseArray).then(() => {
        // console.log("otherFilesData uploaded :- ", otherFilesData);
        callback(otherFilesData);
      });
    },
    (error) => {
      // uploadFiles
      let promiseArray = [];
      _.map(otherFilesData, (field, key) => {
        // Files base64 value
        let savedValues = field.value;
        let uploadFiles = [];
        _.map(savedValues, (item, index) => {
          if (item) {
            promiseArray.push(
              new Promise((resolve, reject) => {
                let file = item?.file;
                let name = item?.filename;
                if (file.search(";base64,") > 0) {
                  let split = file.split(";base64,");
                  var content = split[1];
                  var filename = `${filepath}/${generateFileName(name)}`;

                  var fileJson = {
                    resource: [
                      {
                        name: filename,
                        type: "file",
                        is_base64: true,
                        content: content,
                      },
                    ],
                  };

                  uploadEncodedFile(
                    `${BASE_IMAGES_URL}?check_exist=false`,
                    session,
                    fileJson,
                    dispatch,
                    (data) => {
                      uploadFiles.push(data.name);
                      resolve();
                    },
                    (error) => {
                      resolve();
                    }
                  );
                } else {
                  uploadFiles.push(file);
                  resolve();
                }
              })
            );
          }
        });

        field.value = uploadFiles;
      });

      Promise.all(promiseArray).then(() => {
        // console.log("otherFilesData uploaded :- ", otherFilesData);
        callback(otherFilesData);
      });
    }
  );
}
